import React, { useContext } from "react";
import Dashboard from "../Pages/Dashboard/Dashboard";
import RoutesPath from "../Utils/RoutesPath";
import Login from "../StudentPanel/Auth/Login";
import ForgotPassword from "../StudentPanel/Auth/ForgotPassword";
import OTPVerify from "../StudentPanel/Auth/OtpVerify";
import ResetPassword from "../StudentPanel/Auth/ResetPassword";
import { Navigate, Route, Routes } from "react-router-dom";
import { AuthContext } from "../Context/authContext";
const AllRoutes = () => {
  const { isAuthenticated } = useContext(AuthContext);
  return (
    <div>
      <Dashboard />
    </div>

  );
};

export default AllRoutes;
